import React from "react";
import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";
import { withTheme } from "@emotion/react";
import { CardContent as MuiCardContent, Card as MuiCard, Stack, CircularProgress } from "@mui/material";

import { CardStyle } from "../../../common/styled.js";

import VectorMap from "../../../application/lazy/VectorMap";
import { CountryData } from "../../../home/country.js";
import colors from "../../../../../utils/colors.js";

const pulsate = keyframes`
  0% {
    stroke-width: 0;
    stroke-opacity: 0.8;
  }
  100% {
    stroke-width: 15;
    stroke-opacity: 0;
  }
`;

const Card = styled(MuiCard)`
  position: relative;
  border-radius: 3px;
  width: calc(100%- 258px);
  height: calc(40vw - 90px);
  ${CardStyle};
`;
const CardContent = styled(MuiCardContent)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  &:last-child {
    padding-bottom: ${(props) => props.theme.spacing(4)};
  }
  
  .jvectormap-marker {
    stroke: #6371F7;
    animation: ${pulsate} 1.5s ease-out infinite;
  }
`;
function World({ regional_detections }) {
  const [options, setOptions] = React.useState({
    map: "world_mill",
    regionStyle: {
      initial: {
        fill: "#CFDCF5",
      },
    },
    backgroundColor: "transparent",
    containerStyle: {
      width: "100%",
      height: "100%",
    },
    markerStyle: {
      initial: {
        r: 4,
        fill: "#6371F7",
        "fill-opacity": 1,
        stroke: "#6371F7",
        "stroke-width": 7,
        "stroke-opacity": 0.4,
      },
      hover: {
        stroke: "#07f",
        "fill-opacity": 1,
        "stroke-width": 1.5,
      },
    },
    markers: [],
    zoomOnScroll: false,
  });

  React.useEffect(() => {
    if (regional_detections && regional_detections?.length > 0) {
      var markers = [];
      for (let regional_detection of regional_detections) {
        const countryData = CountryData[regional_detection.key.toUpperCase()];
        markers.push({
          latLng: [countryData?.x, countryData?.y],
          name: countryData?.country,
          value: regional_detection.doc_count,
        });
      }
      setOptions({
        map: "world_mill",
        regionStyle: {
          initial: {
            fill: "#e3eaef",
          },
        },
        backgroundColor: "transparent",
        containerStyle: {
          width: "100%",
          height: "100%",
        },
        markerStyle: {
          initial: {
            r: 4,
            fill: "#6371F7",
            "fill-opacity": 1,
            "stroke-width": 0,
          },
          hover: {
            stroke: "#07f",
            "fill-opacity": 1,
            "stroke-width": 0,
          },
        },
        markers: markers,
        onMarkerTipShow: function (e, el, code) {
          el.html(el.html() + "<br> (Requests - " + markers[code].value + ")");
        },
        zoomOnScroll: false,
      });
    } else {
      setOptions({
        map: "world_mill",
        regionStyle: {
          initial: {
            fill: "#e3eaef",
          },
        },
        backgroundColor: "transparent",
        containerStyle: {
          width: "100%",
          height: "100%",
        },
        markerStyle: {
          initial: {
            r: 4,
            fill: "#6371F7",
            "fill-opacity": 1,
            "stroke-width": 0,
          },
          hover: {
            stroke: "#07f",
            "fill-opacity": 1,
            "stroke-width": 0,
          },
        },
        markers: [],
        zoomOnScroll: false,
      });
    }
  }, [regional_detections]); // eslint-disable-line react-hooks/exhaustive-deps

  return regional_detections === null ? (
    <Stack alignItems={"center"} justifyContent={"center"} sx={{ height: "100%" }}>
      <CircularProgress sx={{ color: colors.neutral[400] }} />
    </Stack>
  ) : (
    <Card sx={{ boxShadow: "none" }}>
      <CardContent sx={{ background: "white" }}>
        <VectorMap {...options} />
      </CardContent>
    </Card>
  );
}

export default withTheme(World);
